export default __webpack_public_path__ + "f95cf27d8c4fe914b7cbde2e2fe8c552-ferrarelle.svg";